<!--
 * @Author: yangbobolaa 994786855@qq.com
 * @Date: 2023-10-07 14:42:04
 * @LastEditors: yangbobolaa 994786855@qq.com
 * @LastEditTime: 2024-05-16 10:11:35
 * @FilePath: \backend\src\views\pddGoods\goods\List.vue
 * @Description: 商家中心 -- 拼多多管理 -- 商品列表
-->
<template>
  <y-view :loading="isLoading">
    <y-card>
      <query-form :data="formData" titleWidth="100px" :form="dataForm.query" @search="handleSearch" @reset="handleReset"></query-form>
      <query-table ref="yTable" :initColumns="initColumns" :dataForm="dataForm" :handleList="handleList" @loadingClose="isLoading = false" @loadingOpen="isLoading = true"></query-table>
    </y-card>
    <k-popup :title="showPopupType === 'add' ? '新增商品' : showPopupType === 'edit' ? '编辑' : ''" :show.sync="isShowAddPopup" @after-ok="onSave">
      <y-popup-body size="large">
        <k-table max-height="calc(70vh - 80px)" :data="editPara.itemList" :columns="addColumns"></k-table>
        <div class="brand_Add mb-1" @click="onAddLine">
          <k-icon name="k-icon-add" style="color: #3386fe;" />
          新增
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>
<script>
import {
  MALL_CODE_RELATION_PACKAGE_ADD,
  MALL_CODE_RELATION_PACKAGE_DETAIL,
  MALL_CODE_RELATION_PACKAGE_EDIT,
  MALL_CODE_RELATION_PACKAGE_ENABLE,
  MALL_CODE_RELATION_PACKAGE_LIST,
} from "@/assets/modules/pinduooApiList";
import common from "@/assets/modules/util/common";
import reg from "@/assets/modules/regExp";

const initEditPara = () => ({
  itemList: [],
  pddCode: "",
});

const initEditItemPara = () => ({
  baseCode: "",
  quantity: "",
  price: "",
  interceptByQty: 0,
  supplyBatch: ''
});

export default {
  data() {
    return {
      isSaving: false,
      isLoading: false,
      isShowAddPopup: false,
      showPopupType: "", //add 添加  edit 编辑
      editPara: initEditPara(),
      editItem: initEditItemPara(),
      formData: [
        { typeCode: "input", title: "业务中台商品编码", name: "baseCode", placeholder: "请输入业务中台商品编码" },
        { typeCode: "input", title: "店铺商品货号", name: "pddCode", placeholder: "请输入店铺商品货号" },
      ],
      dataForm: {
        baseUrl: window.__CONFIG__.pinduoo_url,
        url: MALL_CODE_RELATION_PACKAGE_LIST,
        tableH: "calc(100vh - 258px)",
        rightFixedNumber: 1,
        query: {
          baseCode: "", //业务中台商品编码
          pddCode: "", //店铺商品货号
        }, //列表查询条件字段
      },
      handleList: [{ type: "add", name: "新增商品", btnType: "primary", btnClick: (val) => this.handleLinkToDetail({}, 1) }],
    };
  },

  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w || 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    /** 初始化表格字段 */
    initColumns() {
      return [
        { name: "店铺商品货号", style: this.tableStyle(150), customRender: (row) => <div>{row.pddCode ? row.pddCode : "——"}</div> },
        { name: "是否组合装", style: this.tableStyle(150), customRender: (row) => <div>{row.isPackage ? "是" : "否"}</div> },
        { name: "是否指定批次", style: this.tableStyle(150), customRender: (row) => <div>{row.isSpecifyBatch ? "是" : "否"}</div> },
        {
          name: "业务中台商品编码",
          style: this.tableStyle(150),
          customRender: (row) => (
            <div>
              {row.codeRelationList.map((v) => (
                <div class={this.css.table_row}> {v.baseCode || "——"}</div>
              ))}
            </div>
          ),
        },
        {
          name: "供货批次",
          style: this.tableStyle(150),
          customRender: (row) => (
            <div>
              {row.codeRelationList.map((v) => (
                <div class={this.css.table_row}>{v.supplyBatch||'——'}</div>
              ))}
            </div>
          ),
        },
        {
          name: "商品数量",
          style: this.tableStyle(150),
          customRender: (row) => (
            <div>
              {row.codeRelationList.map((v) => (
                <div class={this.css.table_row}> {v.quantity || "——"}</div>
              ))}
            </div>
          ),
        },
        {
          name: "商品价格",
          style: this.tableStyle(150),
          customRender: (row) => (
            <div>
              {row.codeRelationList.map((v) => (
                <div class={this.css.table_row}> {v.price || "——"}</div>
              ))}
            </div>
          ),
        },
        {
          name: "商品状态",
          style: this.tableStyle(150),
          customRender: (row) => (
            <div>
              {row.codeRelationList.map((v) => (
                <div class={this.css.table_row}>
                  <k-switch
                    checked={row.isEnable}
                    readonly
                    onClick={() => {
                      this.toggleEnable(row);
                    }}
                  />
                </div>
              ))}
            </div>
          ),
        },
        {
          name: "是否限制数量",
          style: this.tableStyle(150),
          customRender: (row) => (
            <div>
              {row.codeRelationList.map((v) => (
                <div class={this.css.table_row}> {v.interceptByQty ? "是" : "否"}</div>
              ))}
            </div>
          ),
        },
        {
          name: "操作",
          style: this.tableStyle(70),
          customRender: (row) => (
            <div>
              <a class="table-handle-text-color" href="javascript:;" onclick={() => this.handleLinkToDetail(row, 2)}>
                编辑
              </a>
            </div>
          ),
        },
      ];
    },

    /** 启停用切换操作 */
    toggleEnable(row) {
      this.$dialog({
        title: "提示",
        content: `确认${row.isEnable ? "停用" : "启用"}该行数据吗？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            baseUrl: window.__CONFIG__.pinduoo_url,
            api: MALL_CODE_RELATION_PACKAGE_ENABLE,
            para: { id: row.id, isEnable: Number(!row.isEnable) },
          })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.$refs.yTable.init();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 点击新建/编辑操作 */
    handleLinkToDetail(row, showType) {
      switch (showType) {
        case 1:
          this.showPopupType = "add";
          this.editPara = initEditPara();
          this.editPara.itemList.push(common.deepCopy(this.editItem));
          this.isShowAddPopup = true;
          break;

        default:
          this.getDetail(row.pddCode);
          break;
      }
    },

    /** 获取商品详情信息 */
    getDetail(pddCode) {
      this.showPopupType = "edit";
      this.isLoading = true;
      this.$fetch({
        baseUrl: window.__CONFIG__.pinduoo_url,
        api: MALL_CODE_RELATION_PACKAGE_DETAIL,
        para: { pddCode },
      })
        .then((res) => {
          this.isLoading = false;
          this.editPara.pddCode = res.pddCode || "";
          this.editPara.itemList = (res.codeRelationList || []).map((item) => ({ baseCode: item.baseCode, quantity: item.quantity, price: item.price, interceptByQty: item.interceptByQty, supplyBatch: item.supplyBatch }));
          this.isShowAddPopup = true;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 初始化添加商品弹窗表格字段 */
    addColumns() {
      return [
        {
          name: "店铺商品货号",
          style: { ...this.tableStyle(), padding: "10px" },
          customRender: (row) => <k-input placeholder="请输入" v-model={this.editPara.pddCode} clearable={this.showPopupType !== "edit"} block={true} disabled={this.showPopupType === "edit"} />,
        },
        {
          name: "业务中台商品编码",
          style: { ...this.tableStyle(), padding: "10px" },
          customRender: (row) => <k-input placeholder="请输入" v-model={row.baseCode} clearable block />,
        },
        {
          name: "商品数量",
          style: { ...this.tableStyle(), padding: "10px" },
          customRender: (row, index) => (
            <k-input
              placeholder="请输入"
              type="number"
              v-model={row.quantity}
              clearable
              block
              onBlur={() => {
                this.verifyIptVal("quantity", index);
              }}
            />
          ),
        },
        {
          name: "商品单价",
          style: { ...this.tableStyle(), padding: "10px" },
          customRender: (row, index) => (
            <k-input
              placeholder="请输入"
              type="number"
              v-model={row.price}
              clearable
              block
              onBlur={() => {
                this.verifyIptVal("price", index);
              }}
            />
          ),
        },
        {
          name: "是否限制数量",
          style: { ...this.tableStyle(), padding: "10px" },
          customRender: (row) => {
            return (
              <k-select placeholder="请选择" block v-model={row.interceptByQty}>
                <k-option selected={row.interceptByQty === 1} label="是" value={1}>
                  是
                </k-option>
                <k-option selected={row.interceptByQty === 0} label="否" value={0}>
                  否
                </k-option>
              </k-select>
            );
          },
        },
        {
          name: '供货批次',
          style: { ...this.tableStyle(), padding: '10px' },
          customRender: (row,index) => (
            <k-input
              placeholder="请输入"
              v-model={ row.supplyBatch }
              clearable={ true }
              block={ true }
              onBlur={ () => {
                this.verifyIptVal('supplyBatch', index);
              } } />
          )
        },
        {
          name: "操作",
          style: this.tableStyle(40),
          customRender: (row, index) => (
            <a
              href="javascript:void(0)"
              onClick={() => {
                this.deleteRow(index);
              }}
            >
              删除
            </a>
          ),
        },
      ];
    },

    /** 验证输入数量、单价 */
    verifyIptVal(type, index) {
      let val;
      if (type === "quantity") {
        val = this.editPara.itemList[index].quantity;
        if (!/^[1-9]\d*$/.test(val)) {
          this.$root.tip("商品数量必须是大于0的整数");
          this.editPara.itemList[index].quantity = "";
        }
      }
      if (type === "price") {
        val = this.editPara.itemList[index].price;
        if (!reg.money.test(val)) {
          if (val < 0) {
            this.$root.tip("商品单价不能小于0");
            this.editPara.itemList[index].price = "";
          } else {
            this.editPara.itemList[index].price = Math.round(val * 100) / 100;
          }
        }
      }
      if (type === 'supplyBatch') {
        val = (this.editPara.itemList[index].supplyBatch || '').replace(/[^a-zA-Z0-9]/g, '');
        this.editPara.itemList[index].supplyBatch = val;
      }
    },

    /** 添加商品行信息 */
    onAddLine() {
      this.editPara.itemList.push(common.deepCopy(this.editItem));
    },

    /** 删除商品行信息 */
    deleteRow(index) {
      this.$dialog({
        title: "提示",
        content: "确认删除该行数据吗？",
        ok: () => {
          this.editPara.itemList.splice(index, 1);
        },
      });
    },

    /** 保存商品信息 */
    onSave() {
      if (!this.editPara.pddCode) return this.$root.tip("请输入店铺商品货号");
      if (
        this.editPara.itemList.some((item) => {
          return !item.baseCode || !item.quantity || !item.price;
        })
      ) {
        return this.$root.tip("信息填写不完整");
      }
      if (
        !(this.editPara.itemList.every((item) => {
          return item.supplyBatch
        }) || this.editPara.itemList.every((item) => {
          return !item.supplyBatch
        }))
      ) {
        return this.$root.tip("供货批次必须都填或者都不填");
      }
      let api = this.showPopupType === "add" ? MALL_CODE_RELATION_PACKAGE_ADD : this.showPopupType === "edit" ? MALL_CODE_RELATION_PACKAGE_EDIT : "";
      if (!api) return;
      this.isLoading = true;
      this.$fetch({
        baseUrl: window.__CONFIG__.pinduoo_url,
        api,
        para: this.editPara,
      })
        .then(() => {
          this.isLoading = false;
          this.$root.tip("操作成功", "success");
          this.isShowAddPopup = false;
          this.editPara = initEditPara();
          this.showPopupType = "";
          this.$refs.yTable.init();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 根据条件搜索列表数据 */
    handleSearch(params) {
      this.isLoading = true;
      this.dataForm.query = params;
      this.$refs.yTable.reload();
    },

    /** 重置列表查询条件 */
    handleReset() {
      this.isLoading = true;
      this.$refs.yTable.reload();
    },
  },

  created() {
    this.isLoading = true;
  },

  beforeRouteUpdate(to, from, next) {
    this.isLoading = true;
    this.$refs.yTable.refresh();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.table_row {
  box-sizing: content-box;
  line-height: 36px;
  border-bottom: 1px solid #eaecf0;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border: none;
  }
}
</style>
